import { createSlice } from "@reduxjs/toolkit";

export interface PhotoUploadState {
  count: number;
}

const initialState: PhotoUploadState = {
  count: 0,
};

export const photoUploadSlice = createSlice({
  name: "photoUpload",
  initialState,
  reducers: {
    incUploadCount: (state) => {
      state.count += 1;
    },
    decUploadCount: (state) => {
      state.count -= 1;
    },
  },
});

export const { incUploadCount, decUploadCount } = photoUploadSlice.actions;

export default photoUploadSlice.reducer;
